module.exports = __webpack_public_path__ + "static/img/vip22.6fb4ce2.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/vipMember/img/vip22.png
// module id = lUlS
// module chunks = 23